import { Text, type TextProps } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';
import { randomUUID } from '@core/utils/uuid';

import {
  type PdfColumnConfig,
  PdfTable,
  Styles,
  pdfColumnFromConfig,
} from '../../../components/PdfTable';
import { PdfTextWithLine } from '../../components/PdfTextWithLine';

const textStyle: TextProps['style'] = {
  fontSize: '11pt',
};

const renderJsxToPdf = (element: string | ReactElement | null): ReactElement =>
  element as ReactElement;

type SignatureRow = {
  id: string;
  leftValue: ReactElement | null;
  rightValue: ReactElement | null;
};

type PdfSignatureProps = {
  quote: Quote;
  tenantName: string;
};

export const PdfSignatures = (props: PdfSignatureProps): ReactElement => {
  const signatureRows: SignatureRow[] = [
    {
      id: randomUUID(),
      leftValue: (
        <PdfTextWithLine
          text={props.tenantName}
          underline
          borderBottom='none'
          textStyle={textStyle}
        />
      ),
      rightValue: (
        <PdfTextWithLine text='Acceptance' underline borderBottom='none' textStyle={textStyle} />
      ),
    },
    {
      id: randomUUID(),
      leftValue: <PdfTextWithLine text='By:' textStyle={textStyle} />,
      rightValue: <PdfTextWithLine text='Company Name:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: (
        <Text style={[Styles.tableCell, { paddingLeft: '0.5in' }]}>
          {props.quote.user.fullName()}
        </Text>
      ),
      rightValue: <PdfTextWithLine text='Acknowledged By:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: null,
      rightValue: <PdfTextWithLine text='Title:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: null,
      rightValue: <PdfTextWithLine text='Date of Acceptance:' textStyle={textStyle} />,
    },
  ];

  const signatureCols: PdfColumnConfig<SignatureRow>[] = [
    {
      id: 'leftValue',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf: renderJsxToPdf,
    },
    {
      id: 'rightValue',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf: renderJsxToPdf,
    },
  ];

  return <PdfTable columns={signatureCols.map(pdfColumnFromConfig)} rows={signatureRows} />;
};
